import { Component } from '@angular/core';

import { RichTextLinkComponent } from '@digital-platform/rs-cms/feature-ptypes';
import { IconComponent } from '@digital-platform/rs-shared/ui-brand';

@Component({
  selector: 'digital-platform-desktop-nav-side-links',
  templateUrl: './desktop-nav-side-links.component.html',
  styleUrls: ['./desktop-nav-side-links.component.scss'],
  standalone: true,
  imports: [RichTextLinkComponent, IconComponent],
})
export class DesktopNavSideLinksComponent {}
